import { triggerOrQueue } from './queue';

// Class representing managed pixel
export default class Pixel {
	constructor(category, pixel, shouldQueue = false) {
		this.category = category;
		this.pixel = pixel;
		this.shouldQueue = shouldQueue;
	}

	createTrigger() {
		return (...args) => {
			triggerOrQueue(this, this.shouldQueue, args);
		};
	}
}
